import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { Text } from '~/shared/components/Text';
import TextButton from '~/shared/components/TextButton';
import { breakpoints } from '~/theme';

export const TableContainer = styled.div((props) => ({
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const StyledTable = styled.table(({ theme }) => ({
    width: '100%',
    backgroundColor: theme.colors.white,
}));

export const TableRow = styled.tr(({ theme }) => ({
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.grey10,
}));

export const TableHeaderCell = styled.th<{ align?: string }>(({ theme, align = 'left' }) => ({
    paddingInline: theme.space[4],
    textAlign: 'left',
    verticalAlign: 'middle',
    height: 48,
    whiteSpace: 'nowrap',

    ['button']: {
        all: 'unset',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent:
            align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'flex-start',

        ['p']: {
            fontSize: theme.fontSizes.guinea,
        },

        ['svg']: {
            verticalAlign: 'middle',
            height: 24,
            width: 24,
            paddingBottom: 4,
        },
    },
}));

export const TableHeaderText = styled(Text)(() => ({
    minHeight: 24,
}));

export const TableCellLink = styled(Link)(({ theme }) => ({
    color: theme.colors.brandBlue,
    textDecoration: 'underline',
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    textAlign: 'left',
}));

export const TableCell = styled.td(({ theme }) => ({
    height: 48,
    paddingInline: theme.space[4],
    textAlign: 'left',
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.grey10,
    verticalAlign: 'middle',

    p: {
        display: 'inline-block',
    },
}));

export const PageSetter = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.md]: {
        height: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.space[1],
    },
}));

export const PageAmountSelecter = styled.select(({ theme }) => ({
    border: 'none',
    textAlign: 'left',
    backgroundColor: 'transparent',
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
}));

export const Pagination = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[6],
    gridColumn: '1 / 2',
    gridRow: '1 / 2',
}));

export const PageButton = styled(TextButton)(() => ({
    [breakpoints.xs]: {
        display: 'none',
    },
}));

export const SkeletonSpacer = styled.div(() => ({
    height: 2,
}));

export const SkeletonBox = styled.div();

export const Footer = styled.div(({ theme }) => ({
    position: 'relative',
    marginTop: theme.space[4],
    display: 'grid',
}));

export const SelectorWrapper = styled.div(() => ({
    gridColumn: '1 / 2',
    justifySelf: 'start',
    gridRow: '2 / 3',
    alignSelf: 'center',
    [breakpoints.md]: {
        gridRow: '1 / 2',
    },
}));
